import Service from './Service';
import { IAccountForm, IBranchAction } from '../Models/Account';

export default class ServiceAccount extends Service {
	public fetchPage(page: number = 0, pageSize: number = 5, idProfile?: number, order?: string, filters?: any, search?: string) {
		let uri = `user?page=${page}&pageSize=${pageSize}`;
		if (idProfile) {
			uri = `${uri}&filter_IdProfile=${idProfile}`;
		}
		if (filters) {
			const filtersKey = Object.keys(filters);
			for(let i = 0; i < filtersKey.length; i += 1) {
				const key: any = filtersKey[i];
				uri = `${uri}&${key}=${filters[key]}`;
			}
		}
		if (search) {
			uri = `${uri}&search=${search}`;
		}
		if (order) {
			uri = `${uri}&order=${order}`;
		}
		return this.wrapper.get(uri+'&order=-CreatedAt');
	}
	public fetch(id: number) {
		return this.wrapper.get(`user/${id}`);
	}

	public create(accountData: IAccountForm) {
		return this.wrapper.post('user', JSON.stringify(accountData));
	}

	public edit(accountData: IAccountForm, id: number) {
		return this.wrapper.put(`user/${id}`, JSON.stringify(accountData));
	}

	public delete(id: number) {
		return this.wrapper.delete(`user/${id}`);
	}

	public getBranch(id: number) {
		return this.wrapper.get(`user/faena/${id}`);
	}

	public sendBranch(assingData: IBranchAction) {
		return this.wrapper.post('user/faena', JSON.stringify(assingData));
	}

}
